<template>
    <ui-card title-big class="tutorials-wrapper" title="Instrukcje do pobrania">
        <div class="row">
            <div
                v-for="(tutorial, tutorialIdx) in tutorials"
                :key="tutorialIdx"
                :class="`col-12 col-md-6 col-lg-4 p-1 ${tileClass}`"
            >
                <div class="single p-2 py-4">
                    <div>
                        <p class="text-primary text-center m-0">
                            {{ tutorial.name }}
                        </p>
                    </div>
                    <a
                        v-if="tutorial.link"
                        class="mt-3"
                        @click="
                            $functions.downloadFile(
                                tutorial.link,
                                tutorial.name
                            )
                        "
                        download
                    >
                        <the-btn
                            btn-class="btn-secondary btn-sm"
                            class="px-7"
                            text="Pobierz"
                            icon="Download"
                        />
                    </a>
                    <a
                        v-else
                        class="mt-3"
                        :href="`/help-tutorials/${tutorial.path}`"
                        download
                    >
                        <the-btn
                            btn-class="btn-secondary btn-sm"
                            class="px-7"
                            text="Pobierz"
                            icon="Download"
                        />
                    </a>
                </div>
            </div>
        </div>
    </ui-card>
</template>

<script>
import { UiCard } from '../../global/ui'
export default {
    name: 'TutorialsToDownload',
    components: { UiCard },
    props: {
        tileClass: {
            type: String,
            default: ''
        }
    },
    computed: {
        tutorials() {
            return this.$store.getters.getTutorials
        }
    },
    beforeCreate() {
        this.$store.dispatch('snippetsLoad', {
            code: 'snippet006',
            moduleName: 'tutorials'
        })
    }
}
</script>

<style lang="scss" scoped>
@import '../../../styles/_custom.scss';
@import '~bootstrap/scss/mixins';
.tutorials-wrapper {
    height: 100%;
    .single {
        display: flex;
        border: 1px solid var(--color-gray-300);
        border-radius: 5px;
        align-items: center;
        height: 100%;
        flex-direction: column;
        justify-content: space-between;
        box-shadow: 0 0 10px -3px var(--color-gray-300);
    }
}
</style>
